package com.merkost.handpass.api.enums

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class AccountStatus(val value: String) {
    @SerialName("active") ACTIVE("active"),
    @SerialName("warned") WARNED("warned"),
    @SerialName("suspended") SUSPENDED("suspended"),
    @SerialName("banned") BANNED("banned"),
    @SerialName("deleted") DELETED("deleted");

    companion object {
        fun fromString(value: String): AccountStatus =
            entries.find { it.value == value.lowercase() } ?: ACTIVE

        fun fromDbValue(value: String): AccountStatus = fromString(value)
    }
}
